import React from "react";
import { QrCode, ShoppingBag, Gift, MessageCircle } from "lucide-react";
import { darken } from "../context/AppSettingsContext";

// Anteprima live della Web App Cliente mentre si sceglie il colore brand (Impostazioni → Colori)
export default function BrandPreview({ color, appName }) {
  const brand = /^#[0-9a-fA-F]{6}$/.test(color || "") ? color : "#1E40AF";
  const dark = darken(brand);
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-950 p-4" data-testid="brand-preview">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-3">Anteprima Web App Cliente · <span className="font-mono" data-testid="brand-preview-hex">{brand}</span></div>
      <div className="mx-auto max-w-[300px] rounded-[26px] border border-zinc-700 bg-white text-zinc-900 p-3 space-y-3 shadow-xl">
        <div className="flex items-center justify-between px-1">
          <span className="text-[10px] font-bold uppercase tracking-widest px-2 py-0.5 rounded-full" style={{ background: `${brand}14`, color: brand }}>{appName || "Vivi Fidelity Club"}</span>
          <span className="h-6 w-6 rounded-full" style={{ background: brand }} />
        </div>
        <div className="rounded-2xl p-4 text-white" style={{ background: `linear-gradient(135deg, ${brand} 0%, ${dark} 100%)` }} data-testid="brand-preview-card">
          <div className="text-[10px] uppercase tracking-widest opacity-80">La tua carta</div>
          <div className="flex items-center justify-between mt-1">
            <div>
              <div className="font-heading text-2xl font-extrabold">120 <span className="text-xs font-semibold opacity-80">punti</span></div>
              <div className="font-mono text-xs opacity-80">W254875</div>
            </div>
            <div className="h-12 w-12 rounded-lg bg-white flex items-center justify-center"><QrCode className="h-8 w-8" style={{ color: brand }} /></div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {[["Ordini", ShoppingBag], ["Premi", Gift], ["Chat", MessageCircle]].map(([l, I]) => (
            <div key={l} className="rounded-xl border border-zinc-200 p-2 text-center">
              <I className="h-4 w-4 mx-auto" style={{ color: brand }} />
              <div className="text-[10px] mt-1 font-semibold text-zinc-700">{l}</div>
            </div>
          ))}
        </div>
        <button type="button" className="w-full h-9 rounded-md text-white text-xs font-semibold" style={{ background: brand }} data-testid="brand-preview-button">Invia richiesta al negozio</button>
        <div className="text-center text-[10px]" style={{ color: dark }}>Registrati in 30 secondi.</div>
      </div>
    </div>
  );
}
